import React, {Component} from "react";
//import Footer from "./Footer";
import axios from "axios";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/buyer/`
})
const UserApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/user/UserAPI/`
})

class AdminPayments extends Component{
    constructor(props) {
        super(props);
        this.state = {
            payments : [],
        }
    }
    componentDidMount(){
        this.getPayments(this.props.state);
    }
    
    getPayments = async (status) => {
        let data = await api.get(`StripePaymentsOrdersAPI/${status}/`).then(({data})=>data);
        //this.setState({payments:data.data})
        data.map(a =>
            this.getUser(a,data)
        )  
    }
    getUser= async (a,data) => {
        let data1 = await UserApi.get(`/${a.buyer}/`).then(({data})=>data);
        a.buyer1=data1[0].first_name
        a.email1=data1[0].email
        //for seller
        let data2 = await UserApi.get(`/${a.seller}/`).then(({data})=>data);
        a.seller1=data2[0].first_name
        a.email2=data2[0].email
        this.setState({payments:data}) 
    }
    updateOrderStatus = async(id) => {
        let data = new FormData();
        data.append('payment_method','stripe t' );
        await api.put(`OrdersAPI/${id}/`, data)
        this.setState({payments:[]}) 
        this.getPayments(this.props.state)
    }
    render() {
        return(
            <>
            <br/><br/>
            <div className='ms-5 me-5  mt-5'>
            {this.props.state==='stripe' ?
            <h1 style={{display: 'inline'}}><b>New Credit Card Payments</b></h1>
            :
            <h1 style={{display: 'inline'}}><b>Transfered Payments</b></h1>
            }
                <table className="table table-striped table-bordered mt-2">
                <thead>
                    <tr className="table-dark" style={{fontSize:'12px'}}>
                        <th scope="col">Buyer</th>
                        <th scope="col">Buyer Mobile</th>
                        <th scope="col">Seller</th>
                        <th scope="col">Seller EasyPaisa</th>
                        <th scope="col">Payment</th>
                        <th scope="col">Order Status</th>
                        <th scope="col" className="text-center">Date & Time</th>
                        {this.props.state==='stripe' ?
                        <th scope="col">Action</th>
                        : null}
                    </tr>
                </thead>
                <tbody>
                {this.state.payments.map(a =>
                a.payment_method === this.props.state?
                <tr key={a.id} style={{fontSize:'12px'}}>
                    <td>{a.buyer1} (<span style={{color:'green'}}>{a.email1}</span>)</td> 
                    <td>{a.mobile}</td>
                    <td>{a.seller1} (<span style={{color:'green'}}>{a.email2}</span>)</td> 
                    <td>03057678512</td> 
                    <td>{a.price*1}</td>
                    <td>{a.status === 'completed' || a.status === 'shipped' ? <span style={{color:'green'}}>Completed</span> : <span style={{color:'red'}}>Not Completed</span>}</td>
                    <td>{a.created_at.slice(12,16)} <span>&nbsp;&nbsp;</span>{a.created_at.slice(0,10)} </td>
                    {this.props.state==='stripe' ?
                    <td><button title='Payment is transfered to seller Account' style={{border: 'none',backgroundColor: 'transparent'}} onClick={()=>this.updateOrderStatus(a.id)}><i class="fa fa-send" style={{fontSize:'20px',color:'red'}}></i></button></td>
                    :null}
                </tr>
                :
                null
                )}
                </tbody>
                </table>
            </div>
           
            </>
        )
    }
} 
export default AdminPayments;